import React, { useState, useEffect, useContext } from "react";

import RoadSegmentTable from "./RoadSegmentTable";
import SummaryTable from "./SummaryTable";

import { useGlobalState, useGlobalUpdater } from "../common/GlobalContext";

export default function DataLayout(props) {
  const query = useGlobalState();
  const dispatch = useGlobalUpdater();

  const { mode } = props;

  const [rows, setRows] = useState([]);
  const [roads, setRoads] = useState([]);
  const [roadsID, setRoadsID] = useState(0);
  const [roadsData, setRoadsData] = useState([]);
  const [roadsData2, setRoadsData2] = useState([]);

  useEffect(() => {
    dispatch({
      type: "setUserSelection",
      selection: {
        route_id: "",
        beg_point: NaN,
        end_point: NaN,
      },
    });

    dispatch({
      type: "setUserSelectionMD100",
      selection: {
        route_id: "",
        beg_point: NaN,
        end_point: "",
      },
    });

    setRoads([]);
    setRoadsID(0);
    setRoadsData([]);
    setRows([]);

    dispatch({
      type: "setUserSelectedSegments",
      selection: [],
    });
  }, [query.layerSpecs.layer]);

  return (
    <div>
      {query.reportType === "Summary" && (
        <SummaryTable layerID={query.statsLayerDesc} mode={mode} />
      )}
      {query.reportType === "User Selected Segments" && (
        <RoadSegmentTable
          rows={rows}
          setRows={setRows}
          roadsData2={roadsData}
          setRoadsData2={setRoadsData}
          mode={mode}
        />
      )}
    </div>
  );
}
